import type {UserSettingsState} from './slice';

export const selectUserSettingsState = (state: WikiState) => state.userSettings;
export const selectUserSettingByKey =
    <K extends keyof UserSettingsState>(key: K) =>
    (state: WikiState) =>
        state.userSettings[key];
